"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TandC = void 0;
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("@concur/nui-widgets/lib/Modal/Modal"));
var _Button = _interopRequireDefault(require("@concur/nui-widgets/lib/Buttons/Button"));
var _BusyIndicator = _interopRequireDefault(require("@concur/nui-widgets/BusyIndicator"));
var _MessageStrip = _interopRequireDefault(require("@concur/nui-widgets/MessageStrip"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _has2 = _interopRequireDefault(require("lodash/has"));
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/terms.css") : void 0;
var _TermsPanel = _interopRequireDefault(require("./TermsPanel"));
var _analytics = require("../constants/analytics");
var _termsModule = require("./termsModule");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var CARDS_TERMS_CHECKBOX_ID = 'cards-terms-checkbox';
var UBER_FOR_BUSINESS_VIP_SCOPE = 'spend.vip.uber.read';
var TandC = exports.TandC = function TandC(_ref) {
  var terms = _ref.terms,
    userId = _ref.userId,
    toggleModal = _ref.toggleModal,
    toggleNeedAnAccountClicked = _ref.toggleNeedAnAccountClicked,
    updateTermsStatus = _ref.updateTermsStatus,
    connect = _ref.connect,
    listingId = _ref.listingId,
    v1ListingId = _ref.v1ListingId,
    flow = _ref.flow,
    clientOptInType = _ref.clientOptInType,
    listing = _ref.listing,
    formatter = _ref.formatter,
    trackButtonClick = _ref.trackButtonClick,
    trackLinkClick = _ref.trackLinkClick,
    companyUUID = _ref.companyUUID;
  var isTaCModalOpen = terms.isTaCModalOpen,
    content = terms.content,
    appcenterStatus = terms.appcenterStatus,
    sharedInfoStatus = terms.sharedInfoStatus,
    sharedInfo = terms.sharedInfo,
    loa = terms.loa,
    readyState = terms.loa.content.readyState,
    tAndCLinkClicked = terms.tAndCLinkClicked,
    _terms$cards = terms.cards,
    cardsTermsAccepted = _terms$cards.accepted,
    cardsTermsContent = _terms$cards.content,
    contentFetched = terms.contentFetched,
    sharedInfoFetched = terms.sharedInfoFetched;
  var _listing$data = listing[(0, _has2.default)(listing, listingId) ? listingId : v1ListingId].data,
    _listing$data2 = _listing$data === void 0 ? {} : _listing$data,
    _listing$data2$core = _listing$data2.core,
    _listing$data2$core2 = _listing$data2$core === void 0 ? {} : _listing$data2$core,
    listingName = _listing$data2$core2.listingName,
    useCardsTermsInsteadOfLoa = _listing$data2$core2.useCardsTermsInsteadOfLoa,
    _listing$data2$locali = _listing$data2.localized,
    _listing$data2$locali2 = _listing$data2$locali === void 0 ? {} : _listing$data2$locali,
    partnerTermsURL = _listing$data2$locali2.partnerTermsURL,
    partnerPolicyURL = _listing$data2$locali2.partnerPolicyURL;
  var _useState = (0, _react.useState)(cardsTermsAccepted),
    _useState2 = _slicedToArray(_useState, 2),
    cardsTermsChecked = _useState2[0],
    setCardsTermsChecked = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showTermsAcceptanceError = _useState4[0],
    setShowTermsAcceptanceError = _useState4[1];
  var ADMIN = 'ADMIN';
  var handleClickTermsLearnMoreLink = function handleClickTermsLearnMoreLink() {
    trackLinkClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.termsAndConditions],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
  };
  var createHTMLMarkup = function createHTMLMarkup(html) {
    return {
      __html: html
    };
  };
  var handleCheckboxUpdate = function handleCheckboxUpdate(e) {
    var _e$target = e.target,
      id = _e$target.id,
      checked = _e$target.checked;
    // We should avoid coupling HTML elements' ID's with the name of a field
    if (id === CARDS_TERMS_CHECKBOX_ID) {
      // Starting now we should instead adapt the ID to the field name
      updateTermsStatus(_termsModule.CARDS_TERM_STATUS_TYPE, checked);
    }
    updateTermsStatus(e.target.id, e.target.checked);
  };
  var concurPrivacyPolicy = /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://www.concur.com/en-us/processor-privacy-statement"
  }, formatter.formattedMessage('ProcessorPrivacyStatement'));
  var LOATerms = /*#__PURE__*/_react.default.createElement(_TermsPanel.default, {
    checkboxId: "loaStatus",
    showCheckbox: !tAndCLinkClicked,
    checked: loa && loa.status.currentlyAccepted,
    onChange: handleCheckboxUpdate,
    title: formatter.formattedMessage({
      id: 'AccessAuthorization'
    }),
    description: formatter.formattedMessage({
      id: 'AccessAuthorizationDescription'
    }),
    expandButtonId: "loaStatusExpandButton",
    contentContainerId: "loaStatusContent"
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: createHTMLMarkup(loa && loa.content && loa.content.html)
  }));
  var isNUI = window.location.pathname.indexOf('nui') >= 0;
  var loaLink = "".concat(isNUI ? '/nui' : '', "/appcenter/terms/loa");
  var linkToPartnerTerms = partnerTermsURL ? /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: partnerTermsURL
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "PartnerTermsURL"
  })) : /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "PartnerTermsURL"
  });
  var linkToLoaTerms = /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: loaLink
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "AccessAuthorization"
  }));
  var listingNeedsLoaTermsToBeAcceptedToConnectToIt = clientOptInType === ADMIN && !useCardsTermsInsteadOfLoa;
  var showLoaTermsPanel = listingNeedsLoaTermsToBeAcceptedToConnectToIt && (tAndCLinkClicked || !loa.status.previouslyAccepted);
  var listingNeedsCardsTermsToBeAcceptedToConnectToIt = clientOptInType === ADMIN && useCardsTermsInsteadOfLoa;
  var showCardsTermsPanel = listingNeedsCardsTermsToBeAcceptedToConnectToIt && (tAndCLinkClicked || !cardsTermsAccepted);
  var getContent = function getContent() {
    if (!contentFetched || !sharedInfoFetched || readyState === 'FETCHING') {
      return /*#__PURE__*/_react.default.createElement(_BusyIndicator.default, {
        visible: true,
        "data-testid": "terms-modal-busy-indicator"
      });
    }
    var AppCenterTerms = /*#__PURE__*/_react.default.createElement(_TermsPanel.default, {
      checkboxId: "appcenterStatus",
      title: formatter.formattedMessage({
        id: 'TermsAppCenterTitle'
      }),
      description: formatter.formattedMessage({
        id: 'TermsAppCenterDescription'
      }),
      checked: appcenterStatus.currentlyAccepted,
      onChange: handleCheckboxUpdate,
      showCheckbox: !tAndCLinkClicked,
      expandButtonId: "appcenterStatusExpandButton",
      contentContainerId: "appcenterStatusContent"
    }, /*#__PURE__*/_react.default.createElement("div", {
      dangerouslySetInnerHTML: createHTMLMarkup((0, _find2.default)(content, {
        type: 'appcenter'
      }).content)
    }));
    var sharedInfoTerms = /*#__PURE__*/_react.default.createElement(_TermsPanel.default, {
      checkboxId: "sharedInfoStatus",
      title: formatter.formattedMessage({
        id: 'TermsAccessAuthTitle'
      }),
      description: formatter.formattedMessage({
        id: 'TermsAccessAuthDescription'
      }),
      checked: sharedInfoStatus.currentlyAccepted,
      onChange: handleCheckboxUpdate,
      showCheckbox: !tAndCLinkClicked,
      expandButtonId: "sharedInfoStatusExpandButton",
      contentContainerId: "sharedInfoStatusContent"
    }, /*#__PURE__*/_react.default.createElement("p", null, partnerPolicyURL ? /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: createHTMLMarkup(formatter.formattedMessage({
        id: 'TermsAccessAuthSubtitle',
        values: {
          partnerPolicyURL: partnerPolicyURL
        }
      })),
      onClick: handleClickTermsLearnMoreLink
    }) : /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: createHTMLMarkup(formatter.formattedMessage('TermsAccessAuthSubtitleWithoutPartnerPolicyURL'))
    })), /*#__PURE__*/_react.default.createElement("ul", null, sharedInfo.map(function (el, i) {
      if (el.code === UBER_FOR_BUSINESS_VIP_SCOPE) {
        return /*#__PURE__*/_react.default.createElement("li", {
          className: "shared-bullet",
          key: i
        }, el.description);
      }
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "shared-bullet",
        key: i
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "https://developer.concur.com/api-reference/authentication/app-center-learn-more.html#".concat(el.scopeTablePath)
      }, el.description));
    })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "ConcurValuesPrivacy",
      values: {
        concurPrivacyPolicy: concurPrivacyPolicy
      }
    })));
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12",
      style: {
        padding: '0px'
      },
      "data-testid": "terms-modal-content"
    }, /*#__PURE__*/_react.default.createElement("h3", null, formatter.formattedMessage({
      id: 'TermsReview'
    })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: clientOptInType === ADMIN ? 'TermsByAcceptEnterprise' : 'TermsByAccept',
      values: {
        loaTermsURL: linkToLoaTerms,
        partnerTermsURL: linkToPartnerTerms
      }
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12",
      style: {
        padding: '0px'
      }
    }, showTermsAcceptanceError ? /*#__PURE__*/_react.default.createElement(_MessageStrip.default, {
      type: "error",
      typeLabel: formatter.formattedMessage({
        id: 'CoreUIComponents.error'
      }),
      message: formatter.formattedMessage({
        id: 'AppCenterV2.errors.genericErrorWithoutId'
      })
    }) : null, tAndCLinkClicked || !appcenterStatus.previouslyAccepted ? AppCenterTerms : null, tAndCLinkClicked || flow !== 'WEBFLOW' ? sharedInfoTerms : null, showLoaTermsPanel ? LOATerms : null, showCardsTermsPanel ? /*#__PURE__*/_react.default.createElement(_TermsPanel.default, {
      checkboxId: CARDS_TERMS_CHECKBOX_ID,
      showCheckbox: !tAndCLinkClicked,
      checked: cardsTermsChecked,
      onChange: function onChange(event) {
        setCardsTermsChecked(event.target.checked);
      },
      title: formatter.formattedMessage({
        id: 'AccessAuthorization'
      }),
      description: formatter.formattedMessage({
        id: 'AccessAuthorizationCardsDescription'
      }),
      expandButtonId: "cards-terms-button",
      contentContainerId: "cards-terms-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      dangerouslySetInnerHTML: createHTMLMarkup(cardsTermsContent)
    })) : null));
  };

  // this function is called if terms is fetched and one of the issues occured:
  // 1) Terms Content fetch returned an error
  // 2) returned terms content object is empty
  // 3) Shared Info fetch returned an error
  // 4) LOA fetch returned an error (enterprise listings)
  // In these cases, the below error will be displayed to the user, and the IAgree button will be disabled
  var getFetchFailedError = function getFetchFailedError() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12",
      style: {
        padding: '0px'
      }
    }, /*#__PURE__*/_react.default.createElement(_MessageStrip.default, {
      "data-testid": "fetch-error-message",
      type: "error",
      typeLabel: formatter.formattedMessage({
        id: 'CoreUIComponents.error'
      }),
      message: formatter.formattedMessage({
        id: 'AppCenterV2.errors.genericErrorWithoutId'
      })
    }));
  };
  var shouldDisplayError = contentFetched && content.length === 0 || sharedInfoFetched && typeof sharedInfo === 'undefined' || readyState === 'FAILED';
  var handleCancelClick = function handleCancelClick(e) {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.termsAndConditions, _analytics.button.cancel],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    if (e) {
      e.preventDefault();
    }
    toggleNeedAnAccountClicked(false);
    updateTermsStatus('appcenterStatus', false);
    updateTermsStatus('sharedInfoStatus', false);
    updateTermsStatus('loaStatus', false);
    setCardsTermsChecked(false);
    setShowTermsAcceptanceError(false);
    return toggleModal(false);
  };

  // I wish these could be in Promise.all()
  // but connect has to be REALLY close to the user clicking
  // or else chrome blocks the popup
  var handleAcceptButtonClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var termsPromises, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            trackButtonClick({
              elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.termsAndConditions, _analytics.button.accept],
              dimensions: {
                listingId: listingId,
                listingName: listingName,
                companyUUID: companyUUID
              }
            });
            termsPromises = [(0, _termsModule.updateTerms)('appcenter')];
            if (listingNeedsLoaTermsToBeAcceptedToConnectToIt) {
              termsPromises.push((0, _termsModule.updateTerms)('loa'));
            } else if (listingNeedsCardsTermsToBeAcceptedToConnectToIt) {
              termsPromises.push((0, _termsModule.updateTerms)(_termsModule.CARDS_TERM_STATUS_TYPE));
            }
            _context.p = 1;
            _context.n = 2;
            return Promise.all(termsPromises);
          case 2:
            toggleModal();
            updateTermsStatus('sharedInfoStatus', false);
            return _context.a(2, connect(listingId, v1ListingId, userId));
          case 3:
            _context.p = 3;
            _t = _context.v;
            setShowTermsAcceptanceError(true);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function handleAcceptButtonClick() {
      return _ref2.apply(this, arguments);
    };
  }();
  var renderButtons = function renderButtons() {
    // Button is disabled unless appcenter terms are previously or currently
    // accepted and shared info is currently accepted
    var renderAcceptBtn = function renderAcceptBtn() {
      var disabledBtn = /*#__PURE__*/_react.default.createElement(_Button.default, {
        id: "i-agree-button",
        className: "pull-right",
        disabled: true
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "IAgree"
      }));

      // TODO: do we even need to check previous if we set current = previous on fetch?
      if (!appcenterStatus.currentlyAccepted && !appcenterStatus.previouslyAccepted) {
        return disabledBtn;
      }
      if (!sharedInfoStatus.currentlyAccepted && flow !== 'WEBFLOW') {
        return disabledBtn;
      }
      if (!loa.status.currentlyAccepted && !loa.status.previouslyAccepted && listingNeedsLoaTermsToBeAcceptedToConnectToIt) {
        return disabledBtn;
      }
      if (!cardsTermsAccepted && !cardsTermsChecked && listingNeedsCardsTermsToBeAcceptedToConnectToIt) {
        return disabledBtn;
      }
      if (shouldDisplayError) {
        return disabledBtn;
      }
      return /*#__PURE__*/_react.default.createElement(_Button.default, {
        id: "i-agree-button",
        className: "pull-right",
        onClick: handleAcceptButtonClick
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "IAgree"
      }));
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "tandc-buttons"
    }, renderAcceptBtn(), /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "link",
      className: "pull-right",
      href: "#",
      onClick: handleCancelClick
    }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "Cancel"
    })));
  };
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    show: isTaCModalOpen,
    onHide: handleCancelClick,
    "aria-label": formatter.formattedMessage({
      id: 'TermsModalLabel'
    }),
    size: "md",
    modalContainerClassName: "modal-container",
    "data-testid": "TaC-Modal"
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
    closeLabel: formatter.formattedMessage({
      id: 'Close'
    }),
    closeButton: "true",
    onHide: handleCancelClick
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Title, null, formatter.formattedMessage({
    id: 'TermsTitle'
  }))), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, {
    style: {
      minHeight: '250px'
    }
  }, shouldDisplayError ? getFetchFailedError() : getContent()), !tAndCLinkClicked && /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12 no-padding"
  }, renderButtons())));
};
TandC.propTypes = {
  terms: _propTypes.default.shape({
    isTaCModalOpen: _propTypes.default.bool,
    appcenterTerms: _propTypes.default.string,
    appcenterStatus: _propTypes.default.object,
    sharedInfoStatus: _propTypes.default.object,
    sharedInfo: _propTypes.default.array,
    tAndCLinkClicked: _propTypes.default.bool,
    cards: _propTypes.default.shape({
      accepted: _propTypes.default.bool,
      content: _propTypes.default.string
    }).isRequired,
    loa: _propTypes.default.shape({
      status: _propTypes.default.shape({
        previouslyAccepted: _propTypes.default.bool,
        currentlyAccepted: _propTypes.default.bool
      }),
      content: _propTypes.default.shape({
        html: _propTypes.default.string
      }).isRequired
    }).isRequired,
    contentFetched: _propTypes.default.bool.isRequired,
    sharedInfoFetched: _propTypes.default.bool.isRequired
  }).isRequired,
  flow: _propTypes.default.string,
  clientOptInType: _propTypes.default.string,
  listing: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  listingId: _propTypes.default.string,
  v1ListingId: _propTypes.default.string,
  userId: _propTypes.default.string,
  toggleModal: _propTypes.default.func.isRequired,
  toggleNeedAnAccountClicked: _propTypes.default.func,
  updateTermsStatus: _propTypes.default.func.isRequired,
  connect: _propTypes.default.func.isRequired,
  formatter: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  trackButtonClick: _propTypes.default.func,
  trackLinkClick: _propTypes.default.func,
  companyUUID: _propTypes.default.string
};
var _default = exports.default = (0, _nuiIntlRuntime.withFormatter)(TandC);